import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQEinzelhandelSection = () => <FAQSectionI18n translationPrefix="industryEinzelhandel" bgClass="bg-secondary/30" />;
export default FAQEinzelhandelSection;
